function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { UnstyledForm } from "./UnstyledForm";

/*
    Returns a form that only allows form submission when the fields are validated

    props
        (boolean)  isFormValid  When true, the form will be allowed to submit
        (function) onSubmit
        (jsx)      children
*/

const UnstyledFormValidation = ({
  classPrepend = "unstyled",
  className = "",
  isFormValid,
  onSubmit,
  children,
  ...rest
}) => {
  const handleFormSubmit = e => {
    e.preventDefault();
    if (isFormValid) {
      onSubmit(e);
    }
  };
  return /*#__PURE__*/React.createElement(UnstyledForm, _extends({
    classPrepend: classPrepend,
    className: className,
    onSubmit: handleFormSubmit
  }, rest), children);
};
export { UnstyledFormValidation };